/**
 * useOutposts — OutpostForge frontend (CES standard)
 * Domain hook mirroring the client's useAccounts shape:
 *   const { outposts, loading, error, loadOutposts } = useOutposts();
 */

import { useCallback, useEffect, useState } from 'react';
import { outpostRepository, type OutpostRepository } from '../repositories/OutpostRepository';
import { describeApiError } from '../services/apiErrors';
import type { OutpostSummary } from '../types/outposts';

export function useOutposts(repository: OutpostRepository = outpostRepository) {
  const [outposts, setOutposts] = useState<OutpostSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadOutposts = useCallback(async () => {
    setLoading(true);
    try {
      setOutposts(await repository.getAllOutposts());
      setError(null);
    } catch (err) {
      setError(describeApiError(err));
    } finally {
      setLoading(false);
    }
  }, [repository]);

  useEffect(() => {
    void loadOutposts();
  }, [loadOutposts]);

  return { outposts, loading, error, loadOutposts };
}
